import { HomeScreen } from '@strata/react-page-templates';

export const IncidentManagement = () => (
    <HomeScreen
        illustration={HomeScreen.Illustration.HEART}
        welcomeMessagePartOne="Incident Management"
        messages={[]}
    />
);
